window.Shopify.loadFeatures(
  [
    {
      name: 'consent-tracking-api',
      version: '0.1',
    },
  ],
  (error) => {
    if (error) {
      return
    }

    const marketingAllowed = window.Shopify.customerPrivacy.currentVisitorConsent().marketing

    if (marketingAllowed === 'yes') {
      cartInsightScript()
    }
  }
)

document.addEventListener('visitorConsentCollected', (event) => {
  const marketingAllowed = event.detail.marketingAllowed
  if (marketingAllowed === true) {
    cartInsightScript()
  }
})

function cartInsightScript () {
  const cartInsights = window.dotDigitalCartInsights
  document.addEventListener('visitorConsentCollected', (event) => {
    const marketingAllowed = event.detail.marketingAllowed
    if (marketingAllowed === true) {
      // <<< Dotdigital Abandoned cart script >>>
      const dmPt = {}
      // Change this value to true if you want to enable guest abandoned cart
      dmPt.enableGuestAbandonedCart = false
      dmPt.newsletterForms = '.privy-widget-form'

      // eslint-disable-next-line
      !function(u){function e(t){var e,n,r,i=(e=t.target,n='input[type=email]', (r=e.querySelector(n))&&r.value?r.value:null);i&&a(i)}function a(t){n('dm-subscriber',t,365)}function n(t,e,n){var r;e&&((r=new Date).setTime(r.getTime()+24*n*60*60*1e3),u.cookie=t+'='+e+'; expires='+r.toGMTString()+'; path=/')}function t(t){for(var e=t+'=',n=u.cookie.split(';'),r=0;r<n.length;r++){for(var i=n[r];''==i.charAt(0);)i=i.substring(1,i.length);if(0==i.indexOf(e))return i.substring(e.length,i.length)}return null}dmPt&&(dmPt.enableGuestAbandonedCart&&u.querySelectorAll(dmPt.newsletterForms).forEach(function(t){t.addEventListener('submit',e,!1)}),dmPt.emailSubmitted=t('dm-subscriber'),a(dmPt.emailSubmitted),dmPt.cartId=t('cart'),n('dm-cart',dmPt.cartId,15))}(document);

      if (window.customerEmail && window.customerAcceptsMarketing === true) {
        dmPt('identify', window.customerEmail)
      } else {
        if (dmPt.enableGuestAbandonedCart && dmPt.emailSubmitted && dmPt.emailSubmitted !== '') {
          dmPt('identify', dmPt.emailSubmitted)
        }
      }

      if (dmPt.cartId && dmPt.cartId !== '') {
        dmPt('cartInsight',
          {
            programID: cartInsights.programId,
            cartDelay: 30,
            cartID: dmPt.cartId,
            cartPhase: 'CUSTOMER_LOGIN',
            currency: cartInsights.currency,
            subtotal: cartInsights.subtotal,
            discountAmount: cartInsights.discountAmount,
            taxAmount: 0,
            grandTotal: cartInsights.grandTotal,
            cartUrl: cartInsights.cartUrl,
            lineItems: cartInsights.lineItems
          }
        )
      }
    }
  })
}
